export default __webpack_public_path__ + "static/media/Oak Bark.76b36312.PNG";